import { SquarePen } from "lucide-react";

interface InfoRowProps {
  fieldKey?: any;
  label: string;
  value: any;
  editable?: boolean;
  handleEditClick?: (field: string) => void;
  dateFormat?: string;
}

export function InfoRow({
  fieldKey,
  label,
  value,
  editable,
  handleEditClick,
  dateFormat = "DD-MM-YYYY",
}: InfoRowProps) {
  return (
    <div className="border-b border-[#E3DBD8] py-4">
      <div className="grid grid-cols-12 justify-between items-center">
        <span className="text-base text-gray-600 col-span-4">{label}</span>

        <span className="text-base text-primary-blue font-bold ml-2 col-span-7">
          {value}
        </span>
        {editable && (
          <SquarePen
            className="text-gray-500 col-span-1 cursor-pointer"
            onClick={() => handleEditClick?.(fieldKey)}
          />
        )}
      </div>
    </div>
  );
}
